@if (chapter(); as chapter) {
  <mat-accordion
    #accordion="matAccordion"
    class="tt-smartbook-chapter"
    id="{{ chapter.uniqueId }}"
    multi="true"
    [class.tt-edit-imported-mode]="guidelineViewService?.isEditImportedGuidelineMode()"
    [class.tt-smartbook-chapter--deleted]="chapter.tag?.status === GuidelineTagStatus.DELETED">
    <mat-expansion-panel
      #panel
      class="mat-elevation-z0"
      [expanded]="expanded()"
      [hideToggle]="true"
      (expandedChange)="handleExpandedChange($event)">
      <mat-expansion-panel-header
        class="tt-smartbook-chapter_header-container"
        data-userguide="chapter-header"
        [attr.data-testid]="'tt-chapter-widget_header'">
        <div class="tt-smartbook-chapter_header" ttMobileTextScroll>
          <div
            class="tt-smartbook-chapter_header-title"
            ttCommentableElement
            [class]="chapterLevel()"
            [elementId]="`${chapter.uniqueId}_title`"
            [widgetId]="chapter.uniqueId">
            {{ numbering() }}.&nbsp;{{ chapter.title }}
          </div>

          @if (guidelineViewService?.isEditImportedGuidelineMode() && (chapterHasLocalChanges() || childrenHaveLocalChanges())) {
            <common-chip data-testid="smartbook-chapter_chip-edited" [variant]="'disabled'">
              {{ 'SingleGuidelineManager.ImportedGuideline.Editor.Edited' | transloco }}
            </common-chip>
          }

          @if (isEditMode()) {
            <div class="tt-smartbook-chapter_tags">
              <tt-resource-tag-list [tags]="selectedResourceTags()" (tagRemoved)="removeTag($event)" />
              <button
                #tagTriggerButton
                ttButton
                [emphasis]="'minimal'"
                [size]="'small'"
                [variant]="'secondary'"
                (click)="openTagDropdown($event)">
                <mat-icon [icon]="'plus'" [iconSize]="14" />
                @if (!selectedResourceTags()?.length) {
                  {{ 'ResourceTag.AddTag' | transloco }}
                }
              </button>
            </div>

            <ng-template #addResourceTagsTemplate>
              <tt-add-resource-tags [selectedTags]="selectedResourceTags()" (tagsChanged)="handleResourceTagLocalChanges($event)" />
            </ng-template>
          } @else {
            <tt-resource-tag-list [readonly]="true" [tags]="selectedResourceTags()" />
          }

          <tt-attachments-links-references-tag
            class="tt-smartbook-chapter_header_tags"
            [attachments]="attachments()"
            [isPreviewMode]="guidelineViewService?.isPreviewMode()"
            [isPublicPage]="guidelineViewService?.isPublicPage()"
            [links]="chapter.links"
            [references]="chapter.references" />

          <div class="tt-smartbook-chapter_header-divider"></div>

          @if (showEditImportedGuidelineButtons()) {
            <div class="tt-smartbook-chapter_header-actions">
              @if (isEditMode()) {
                <button
                  class="tt-smartbook-chapter_header-actions-action tt-smartbook-chapter_header-actions-button"
                  [attr.data-testid]="'editable-guideline_edit-attachments-button'"
                  (click)="openAttachmentDialog($event)">
                  <mat-icon [icon]="'paperclip'" [iconSize]="14" />
                  {{ 'SingleGuidelineManager.ImportedGuideline.Editor.EditAttachments' | transloco }}
                </button>
              }
              <button
                class="tt-smartbook-chapter_header-actions-action"
                ttButton
                [attr.data-testid]="'editable-guideline_edit-button'"
                [class.tt-smartbook-chapter_header-actions-action--on]="isEditMode()"
                [ttTooltip]="'SingleGuidelineManager.ImportedGuideline.Editor.ToggleEditModeTooltip' | transloco"
                [variant]="'transparent'"
                (click)="toggleEditMode($event)">
                <mat-icon [icon]="'pencil'" [iconSize]="14" />
              </button>
              @if (childrenHaveLocalChanges()) {
                <button
                  class="tt-smartbook-chapter_header-actions-action"
                  data-testid="editable-guideline_toggle-compare-view-button"
                  ttButton
                  [class.tt-smartbook-chapter_header-actions-action--disabled]="hasMergeConflict()"
                  [class.tt-smartbook-chapter_header-actions-action--on]="isCompareMode()"
                  [variant]="'transparent'"
                  (click)="toggleCompareMode($event)">
                  <mat-icon
                    [icon]="'git-compare-arrows'"
                    [iconSize]="14"
                    [ttTooltip]="
                      (hasMergeConflict()
                        ? 'SingleGuidelineManager.ImportedGuideline.Editor.ToggleCompareModeDisabledTooltip'
                        : 'SingleGuidelineManager.ImportedGuideline.Editor.ToggleCompareModeTooltip'
                      ) | transloco
                    " />
                </button>
              }
            </div>
          }

          @if (tag()) {
            <tt-guideline-update-tag
              class="tt-smartbook-chapter_local-tag"
              data-testid="smartbook-chapter_chip-updated"
              [readonly]="!allowEditTags()"
              [tag]="tag()"
              (tagUpdated)="handleTagUpdated($event)" />
          }

          @if (hasContent()) {
            <div class="tt-smartbook-chapter_header-expand">
              <mat-icon
                class="tt-smartbook-chapter_header-expand-icon"
                [class.tt-smartbook-chapter_header-expand-icon--expanded]="expanded()"
                [icon]="'chevron-down'"
                [iconSize]="16" />
            </div>
          }
        </div>
      </mat-expansion-panel-header>
      @if (hasContent() || guidelineViewService?.isEditImportedGuidelineMode()) {
        <div class="tt-smartbook-chapter_content" [attr.data-testid]="'tt-chapter-widget_content'">
          @for (widgetId of chapter.widgetIds; track widgetId) {
            <tt-widget
              [allowEditTags]="allowEditTags()"
              [chapterTitle]="chapter.title"
              [widgetId]="widgetId"
              [(isCompareMode)]="isCompareMode"
              [(isEditMode)]="isEditMode" />
          }
        </div>
      }
    </mat-expansion-panel>
  </mat-accordion>

  @if (chapter.childrenIds?.length > 0) {
    <tt-chapter-widget-list [chapterIds]="chapter.childrenIds" [numbering]="numbering()" [parentChapterId]="chapter.uniqueId" />
  }
}
